import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import tfgApi from '@/features/dashboard/tfg/api/tfgApi.ts';
import { tfgApiQueryKeys } from '@/features/dashboard/tfg/api/tfgApi.queryKeys.ts';
import { YearMonth } from '@/features/dashboard/tfg/types/month.ts';
import { TfgDeklaracjaPreviewDto } from '@/features/dashboard/tfg/types/TfgDeklaracjaPreviewDto.ts';

/**
 * Query options for the TFG declaration preview. The projection is live and
 * never persisted, so it is always fetched fresh (`staleTime: 0`). Used with
 * `queryClient.fetchQuery` to fetch on demand when the generate dialog submits.
 */
export const getDeklaracjaPreviewQueryOptions = ({
  year,
  month,
}: YearMonth): UseQueryOptions<TfgDeklaracjaPreviewDto> => ({
  queryKey: tfgApiQueryKeys.deklaracjaPreview(year, month),
  queryFn: () => tfgApi.getDeklaracjaPreview(year, month),
  staleTime: 0,
  gcTime: 0,
});

const useGetDeklaracjaPreview = (params: YearMonth | null) =>
  useQuery({
    queryKey: tfgApiQueryKeys.deklaracjaPreview(
      params?.year ?? 0,
      params?.month ?? 0,
    ),
    queryFn: () => tfgApi.getDeklaracjaPreview(params!.year, params!.month),
    enabled: params !== null,
    staleTime: 0,
    gcTime: 0,
  });

export default useGetDeklaracjaPreview;
